import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Jeff Anders
 * id C09E8F37-086D-425D-9984-639C3251F340
 * name receipt-send-outline
 * version: 7.2.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/receipt-send-outline.svg
 * tags
 */
export const ReceiptSendOutlineIcon = createSvgIcon(<><path d="M18 2L19.5 3.5L21 2V14.26L19 13.26V5H5V19H12V22L10.5 20.5L9 22L7.5 20.5L6 22L4.5 20.5L3 22V2L4.5 3.5L6 2L7.5 3.5L9 2L10.5 3.5L12 2L13.5 3.5L15 2L16.5 3.5L18 2M14 19L18 18L14 17V13L24 18L14 23V19Z" /></>, 'ReceiptSendOutlineIcon');
export default ReceiptSendOutlineIcon